export default __webpack_public_path__ + "static/media/thumbnail_image_5.b18dba42.png";